import React, { useState } from "react";
import ReservationList from "./ReservationList";
import ReservationMobileList from "./ReservationMobileList";
import ReservationForm from "./ReservationForm";
import { useSelector, useDispatch } from "react-redux";
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup, closeGlobalPopup } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";
import ReservationCalendar from "./ReservationCalendar";
import ReservationStatusForm from "./ReservationStatusForm";
import WaitlistPanel from "./WaitlistPanel";
import ChannelSyncPanel from "./ChannelSyncPanel";
import { fetchReservation } from "../../redux/action";
import "./Reservation.css";

function ReservationsPage() {
  const [action, setAction] = useState(null);
  const edit = useSelector((state) => state?.admin?.edit);
  const reservationSaving = useSelector((state) => Boolean(state?.admin?.reservationSaving));
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const reservations = useSelector((state) => Object.values(state?.admin?.reservations || {}));
  const [statusOperation, setStatusOperation] = useState(null);
  const [activeView, setActiveView] = useState("reservations");

  const closePopUp = () => {
    dispatch({ type: 'EDIT_RESERVATION', payload: null });
    setAction(null);
  }

 const addReservation = () => {
    dispatch({ type: 'EDIT_RESERVATION', payload: null });
    setAction("add-reservation");
    dispatch(openGlobalPopup("add-reservation"));
  }
  const editReservation = () => {
    setAction("edit-reservation");
    dispatch(openGlobalPopup("edit-reservation"));
  };
  const handleStatus = (reservation, action) => {
    if (!action) return;
    setStatusOperation({ reservation, action });
    dispatch(openGlobalPopup("reservation-status"));
  };
  const viewDetails = (reservation) => {
    setStatusOperation({ reservation, action: "Details" });
    dispatch(openGlobalPopup("reservation-status"));
  };
  const completeStatusOperation = () => {
    dispatch(fetchReservation());
    dispatch(closeGlobalPopup());
    setStatusOperation(null);
  };

  return (
    <div className="container">
      <h1>Manage Reservations</h1>

      <button
        className="add-button ui-page-add-button"
        onClick={() => { addReservation(); }}
      >
        Add Reservation
      </button>

      <nav className="reservation-view-tabs" aria-label="Reservation workspace">
        <button type="button" className={activeView === "reservations" ? "active" : ""} onClick={() => setActiveView("reservations")}>Reservations <span>{reservations.length}</span></button>
        <button type="button" className={activeView === "calendar" ? "active" : ""} onClick={() => setActiveView("calendar")}>Calendar</button>
        <button type="button" className={activeView === "waitlist" ? "active" : ""} onClick={() => setActiveView("waitlist")}>Walk-in waitlist</button>
        <button type="button" className={activeView === "channels" ? "active" : ""} onClick={() => setActiveView("channels")}>Channel sync</button>
      </nav>


      <GlobalPopup
        popupKey={action}
        title={edit?.reservationId ? 'Edit Reservation' : 'Add New Reservation'}
        onClose={closePopUp}
        disableClose={reservationSaving}
        footer={(closePopup) => (
          <>
            <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={reservationSaving}>Cancel</button>
            <button type="submit" form="reservation-form" className="popup-action-btn" disabled={reservationSaving} aria-busy={reservationSaving}>
              {reservationSaving ? <><span className="popup-button-spinner" aria-hidden="true" />Saving...</> : edit?.reservationId ? 'Edit Reservation' : 'Add Reservation'}
            </button>
          </>
        )}
      >
        <ReservationForm edit={edit?.reservationId ? edit : undefined} />
      </GlobalPopup>

      <GlobalPopup popupKey="reservation-status" title={statusOperation?.action === "Details" ? "Reservation details" : statusOperation?.action === "NoShow" ? "Mark reservation as no-show" : `${statusOperation?.action || "Update"} reservation`} onClose={() => setStatusOperation(null)}>
        {statusOperation && <ReservationStatusForm {...statusOperation} onSuccess={completeStatusOperation} />}
      </GlobalPopup>

      {activeView === "reservations" && <section className="list-section">
        {isMobile ? (
          <ReservationMobileList onEdit={editReservation} onStatus={handleStatus} onView={viewDetails} />
        ) : (
          <ReservationList onEdit={editReservation} onStatus={handleStatus} onView={viewDetails} />
        )}
      </section>}
      {activeView === "calendar" && <ReservationCalendar reservations={reservations} onAction={handleStatus} />}
      {activeView === "waitlist" && <WaitlistPanel />}
      {activeView === "channels" && <ChannelSyncPanel />}
    </div>
  );
}

export default ReservationsPage;
